import { useState } from 'react';
import type { RoleDefinition } from '../../../app/roles';
import type { AssetJoined } from '../inventory/AssetInventory';
import { ConfirmationReview } from '../../../components/ui/ConfirmationReview';

export function PhoneIdentity({ asset, role }: { asset: AssetJoined, role: RoleDefinition }) {
  const [showConfirm, setShowConfirm] = useState(false);
  const [facing, setFacing] = useState<'front'|'back'>('front');

  return (
    <div className="phone-identity">
      <div className="phone-images">
        <div className="image-container">
          <img src="/brand/icon-512.png" alt="Phone front" className={`phone-img ${facing === 'front' ? 'visible' : 'hidden'}`} />
          <img src="/brand/icon-512.png" alt="Phone back" className={`phone-img ${facing === 'back' ? 'visible' : 'hidden'} back`} />
        </div>
        <div className="image-controls">
          <button className={`button button--small ${facing === 'front' ? 'button--primary' : ''}`} onClick={() => setFacing('front')}>Front</button>
          <button className={`button button--small ${facing === 'back' ? 'button--primary' : ''}`} onClick={() => setFacing('back')}>Back</button>
        </div>
      </div>

      <div className="phone-primary-specs">
        <h2>{asset.assetTag}</h2>
        <p className="subtext">{asset.name}</p>
        <div className="status-row" style={{ display: 'flex', gap: '0.5rem', margin: '0.5rem 0' }}>
          <span className={`status-badge status-${asset.state}`}>{asset.state}</span>
          <span className="mdm-badge mdm-compliant">Condition: Good</span>
        </div>

        <div className="spec-grid">
          <div><strong>Assignee:</strong> {asset.assigneeName || 'None'}</div>
          <div><strong>Department:</strong> {asset.departmentName || 'None'}</div>
          <div><strong>Last Verified:</strong> 2 days ago</div>
        </div>
      </div>

      <div className="phone-actions">
        <button className="button button--primary" disabled={!role.canEditTechnicalRecords} title={!role.canEditTechnicalRecords ? "Insufficient permissions" : ""}>Edit</button>
        <button className="button" disabled={!role.canEditTechnicalRecords}>Reassign</button>
        <button className="button" disabled={!role.canEditTechnicalRecords}>Record Maintenance</button>
        <button className="button button--danger" disabled={!role.canApproveSensitiveChanges} title={!role.canApproveSensitiveChanges ? "Insufficient permissions" : ""} onClick={() => setShowConfirm(true)}>Mark Lost</button>
      </div>

      <ConfirmationReview
        isOpen={showConfirm}
        title="Mark Asset as Lost"
        currentValue={asset.state}
        proposedValue="lost"
        impact="This will alert the MDM to remote wipe the device when it connects to a network."
        actor={role.label}
        onConfirm={(reason) => { console.log(reason); setShowConfirm(false); }}
        onCancel={() => setShowConfirm(false)}
      />
    </div>
  );
}
